import axios from "./http";

let { get, post, patch, siidelete } = axios

export const organization = 'sii'

// post example
export const post_example = data => post("/mcapi/cwcash/executecworder", data)

// get example
export const get_example = data => get("/mcapi/cwcash/getorderinfo", data)

// 获取网站配置
export const getsiteconfig = data => get("/cwapisys/siteconfig/", data)

// 登陆
export const login = data => post("/cwapi/login/", data)

// 注册
export const register = data => post("/cwapi/cwregister/", data)

// 获取用户信息
export const getcwinfo = data => get("/cwapi/collectionworkerinfo/", data)

// 获取我的团队成员
export const getmyteam = data => get("/cwapi/myteam/", data)

// 添加新团队成员
export const addnewteam = data => post("/cwapi/createsubordinateworkers/", data)

// 修改下级成员分红比例
export const editchilderbonusratio = data => post("/cwapi/editchilderbonusratio/", data)

// 给下级转账
export const transfertochild = data => post('/cwapi/transfertochild/', data)

//邀请相关
export const referral = data => get("/cwapi/referral/ ", data)
export const newreferral = data => post("/cwapi/referral/ ", data)
export const delreferral = data => siidelete("/cwapi/referral/ ", data)


// 获取paytm账号列表
export const getcollectiontoollist = data => get('/cwapi/collectiontool/', data)

// 新建paytm账号
export const addcollectiontool = data => post('/cwapi/collectiontool/', data)

export const getcollectiontool = data => get('/cwapi/collectiontool/', data)

export const deletecollectiontool = data => siidelete('/cwapi/collectiontool/', data)

export const editcollectiontool = data => patch('/cwapi/collectiontool/', data)

//订单列表
export const getorderlists = data => get("/cwapi/orderlog/", data)

//资金记录
export const getassetsrecord = data => get("/cwapi/quotalog/", data)

// 获取文章(通过id)
export function getnewsIddetail(id) {
    return get("/news/detail/" + id + "/");
}

// 获取文章(通过code)
export function getnewsCodedetail(code) {
    return get("/news/code/" + code + "/");
}

// 获取新闻列表
export const getnewslist = data => get("/news/list/", data)

// 获取通知
export const getnotice = data => get("/news/notice/", data)

//USDT充值
export const rechargequota = data => post("/cwapi/rechargequota/", data)

//获取代付订单
export const getpayorder = data => get("/cwapi/payorder/", data)

//获取代付订单详情
export const getpayorderinfo = data => get("/cwapi/payorder/", data)

//抢单
export const downorder = data => post("/cwapi/payorder/", data)

//上传图片
export const uploadimage = data => post("/cwapi/upload_image/", data)

//取消订单
export const cancelorder = data => post("/cwapi/cancelpayorder/", data)


//获取自定义配置信息
export const getconfigs = data => get("/cwapisys/getconfigs/", data)


export const orderquery = data => get("/cwapi/rechargequery/", data)

// 发送otp验证码
export const send_otp = data => post("/cwapi/ctotpsend/", data)

// otp登录
export const otp_login = data => post("/cwapi/ctotplogin/", data)

export const authupi = data => post("/cwapi/authupi/", data)

export const cwworkerstate = data => get("/cwapi/cwworkerstate/", data)

// 发送验证码
export const sendsms = data => post('/smsauth/sendsms', data)

// 服务端登录
export const service_login = data => post("/cwapi/ctservicelogin/", data)


// 获取费率
export const getcwexchangerate = data => get('/cwapi/cw_exchangerate/', data)

// 获取客服列表
export const getcwcustomerservicelist = data => get('/cwapi/cw_customer_service_list/', data)

// 排行榜
export const getcwinviterank = data => get('/cwapi/cw_inviterank/', data)

export const getcwprofitrank = data => get('/cwapi/cw_profitrank/', data)

// 获取购买记录(即充值)
export const getusdtbuyitokenlist = data => get('/cwapi/usdtbuyitokenlist/', data)

//获取可用列表
export const availablect = data => get('/cwapi/availablect/', data)


// 获取代付历史
export const gethistorypayorder = data => get('/cwapi/gethistorypayorder/', data)

// 启用挂售
export const startsell = data => post('/cwapi/startsell/', data)

export const stopsell = data => post('/cwapi/stopsell/', data)

export const resetpassword = data => post('/cwapi/resetpassword/', data)

export const teaminfothree = data => get('/cwapi/teaminfothree/', data)

// 获取通知未读数
export const unreadcount = data => get('/cwapi/notify/api/unread_count/ ', data)

// 获取通知未读列表
export const unreadlist = data => get('/cwapi/notify/api/unread_list/ ', data)

// 获取通知列表
export const alllist = data => get('/cwapi/notify/api/all_list/', data)

//消息标记为已读
export const messageasread = data => get('/cwapi/notify/mark-as-read/' + data)

//全部标记为已读
export const allmessageasread = data => get('/cwapi/notify/mark-all-as-read/', data)

// 锁定订单复审
export const billlockquotareview = data => post('/cwapi/billlockquotareview/', data)

// KYC身份验证
export const cwkyc = data => post('/cwapi/cwkyc/', data)

// 获取KYC身份验证信息
export const getcwkyc = data => get('/cwapi/cwkyc/', data)

// 编辑kyc
export const modifykyc = data => patch('/cwapi/cwkyc/', data)

// 收款工具
export const getpayments = data => get('/cwapi/paymentmethod/', data)

// 新增修改
export const postpayment = data => post('/cwapi/paymentmethod/', data)



// WEBPACK FOOTER //
// ./src/request/api.js